import { CMSUrls } from "./cmsHelper";

export const global = () => {
  return {
    id: "1",
    attributes: {
      favicon: {
        data: {
          id: "183",
          attributes: {
            alternativeText: "android_chrome_512x512_3bc84be362.png",
            width: 512,
            height: 512,
            mime: "image/png",
            url: CMSUrls.faviconUrl,
            formats: {
              small: {
                ext: ".png",
                url: CMSUrls.faviconUrl,
                hash: "small_android_chrome_512x512_3bc84be362_434a461eb5",
                mime: "image/png",
                name: "small_android_chrome_512x512_3bc84be362.png",
                path: null,
                size: 68.27,
                width: 500,
                height: 500,
              },
              thumbnail: {
                ext: ".png",
                url: CMSUrls.faviconUrl,
                hash: "thumbnail_android_chrome_512x512_3bc84be362_434a461eb5",
                mime: "image/png",
                name: "thumbnail_android_chrome_512x512_3bc84be362.png",
                path: null,
                size: 11.38,
                width: 156,
                height: 156,
              },
            },
          },
        },
      },
      metadata: {
        metaTitle: "Onmo",
        metaDescription: "ONMO",
        metaImage: {
          data: {
            id: "167",
            attributes: {
              alternativeText: "ONMO_d27c870b24.svg",
              width: 90,
              height: 20,
              mime: "image/svg+xml",
              url: CMSUrls.metaUrl,
              formats: null,
            },
          },
        },
      },
      metadataHome: {
        metaTitle: "Mobile money, in minutes | Onmo",
        metaDescription:
          "Take out an Onmo Credit Card in minutes. Our products are easy to use, we are transparent with charges, and we always put our customers first. ",
        metaImage: {
          data: {
            id: "243",
            attributes: {
              alternativeText: "Homepage.jpg",
              width: 1200,
              height: 628,
              mime: "image/jpeg",
              url: `https://d2f2p28idjlxwt.cloudfront.net/Homepage_88486cdd9d.jpg`,
              formats: {
                large: {
                  ext: ".jpg",
                  url: `https://d2f2p28idjlxwt.cloudfront.net/large_Homepage_88486cdd9d.jpg`,
                  hash: "large_Homepage_88486cdd9d",
                  mime: "image/jpeg",
                  name: "large_Homepage.jpg",
                  path: null,
                  size: 58.54,
                  width: 1000,
                  height: 523,
                },
                small: {
                  ext: ".jpg",
                  url: `https://d2f2p28idjlxwt.cloudfront.net/small_Homepage_88486cdd9d.jpg`,
                  hash: "small_Homepage_88486cdd9d",
                  mime: "image/jpeg",
                  name: "small_Homepage.jpg",
                  path: null,
                  size: 20.21,
                  width: 500,
                  height: 262,
                },
                medium: {
                  ext: ".jpg",
                  url: `https://d2f2p28idjlxwt.cloudfront.net/medium_Homepage_88486cdd9d.jpg`,
                  hash: "medium_Homepage_88486cdd9d",
                  mime: "image/jpeg",
                  name: "medium_Homepage.jpg",
                  path: null,
                  size: 38.55,
                  width: 750,
                  height: 393,
                },
                thumbnail: {
                  ext: ".jpg",
                  url: `https://d2f2p28idjlxwt.cloudfront.net/thumbnail_Homepage_88486cdd9d.jpg`,
                  hash: "thumbnail_Homepage_88486cdd9d",
                  mime: "image/jpeg",
                  name: "thumbnail_Homepage.jpg",
                  path: null,
                  size: 6.76,
                  width: 245,
                  height: 128,
                },
              },
            },
          },
        },
      },
      metaTitleSuffix: "Onmo",
      notificationBanner: null,

      navbar: {
        joinButton: true,
        links: [
          {
            id: "1",
            url: "/help",
            text: "Help & Support ",
          },
          // {
          //   id: "2",
          //   url: "/credit-card",
          //   text: "Credit Card",
          // },
        ],
        logo: {
          data1: {
            id: "214",
            attributes: {
              alternativeText: "Onmo Digital Logo",
              width: 150,
              height: 37,
              mime: "image/svg+xml",
              url: CMSUrls.logoLightUrl,
              formats: null,
            },
          },
          data2: {
            id: "214",
            attributes: {
              alternativeText: "Onmo Digital Logo",
              width: 150,
              height: 37,
              mime: "image/svg+xml",
              url: CMSUrls.logoDarkUrl,
              formats: null,
            },
          },
          metadataAbout: {
            metaTitle: "About Us | Onmo",
            metaDescription:
              "Read about why we're here, what we stand for, and how Onmo helps you make smarter decisions with money - so you can get more from life.",
            metaImage: {
              data: {
                id: "244",
                attributes: {
                  alternativeText: "About-Us.jpg",
                  width: 1200,
                  height: 628,
                  mime: "image/jpeg",
                  url: `https://d2f2p28idjlxwt.cloudfront.net/About_Us_b9fa07b5b9.jpg`,
                  formats: {
                    large: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/large_About_Us_b9fa07b5b9.jpg`,
                      hash: "large_About_Us_b9fa07b5b9",
                      mime: "image/jpeg",
                      name: "large_About-Us.jpg",
                      path: null,
                      size: 75.1,
                      width: 1000,
                      height: 523,
                    },
                    small: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/small_About_Us_b9fa07b5b9.jpg`,
                      hash: "small_About_Us_b9fa07b5b9",
                      mime: "image/jpeg",
                      name: "small_About-Us.jpg",
                      path: null,
                      size: 19.61,
                      width: 500,
                      height: 262,
                    },
                    medium: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/medium_About_Us_b9fa07b5b9.jpg`,
                      hash: "medium_About_Us_b9fa07b5b9",
                      mime: "image/jpeg",
                      name: "medium_About-Us.jpg",
                      path: null,
                      size: 43.86,
                      width: 750,
                      height: 393,
                    },
                    thumbnail: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/thumbnail_About_Us_b9fa07b5b9.jpg`,
                      hash: "thumbnail_About_Us_b9fa07b5b9",
                      mime: "image/jpeg",
                      name: "thumbnail_About-Us.jpg",
                      path: null,
                      size: 4.2,
                      width: 245,
                      height: 128,
                    },
                  },
                },
              },
            },
            canonicalURL: null,
            metaRobots: null,
            keywords: "About Onmo",
            structuredData: "null",
          },
          metadataContact: {
            metaTitle: "Contact Us | Onmo",
            metaDescription:
              "Message, phone, email - and even post! Here's where you can get in touch with us at Onmo Towers.",
            metaImage: {
              data: {
                id: "246",
                attributes: {
                  alternativeText: "Contact.jpg",
                  width: 1200,
                  height: 628,
                  mime: "image/jpeg",
                  url: `https://d2f2p28idjlxwt.cloudfront.net/Contact_91664dd137.jpg`,
                  formats: {
                    large: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/large_Contact_91664dd137.jpg`,
                      hash: "large_Contact_91664dd137",
                      mime: "image/jpeg",
                      name: "large_Contact.jpg",
                      path: null,
                      size: 33.88,
                      width: 1000,
                      height: 523,
                    },
                    small: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/small_Contact_91664dd137.jpg`,
                      hash: "small_Contact_91664dd137",
                      mime: "image/jpeg",
                      name: "small_Contact.jpg",
                      path: null,
                      size: 12.94,
                      width: 500,
                      height: 262,
                    },
                    medium: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/medium_Contact_91664dd137.jpg`,
                      hash: "medium_Contact_91664dd137",
                      mime: "image/jpeg",
                      name: "medium_Contact.jpg",
                      path: null,
                      size: 22.88,
                      width: 750,
                      height: 393,
                    },
                    thumbnail: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/thumbnail_Contact_91664dd137.jpg`,
                      hash: "thumbnail_Contact_91664dd137",
                      mime: "image/jpeg",
                      name: "thumbnail_Contact.jpg",
                      path: null,
                      size: 4.6,
                      width: 245,
                      height: 128,
                    },
                  },
                },
              },
            },
            canonicalURL: null,
            metaRobots: null,
            keywords: null,
            structuredData: null,
          },
          metadataCreditCard: {
            metaTitle: "The Onmo Credit Card",
            metaDescription:
              "Apply for an Onmo Credit Card today and get a decision in minutes. Our app helps you stay in control of your spend and we are transparent with our charges.",
            metaImage: {
              data: {
                id: "247",
                attributes: {
                  alternativeText: "Credit-Card.jpg",
                  width: 1200,
                  height: 628,
                  mime: "image/jpeg",
                  url: `https://d2f2p28idjlxwt.cloudfront.net/Credit_Card_09359e242f.jpg`,
                  formats: {
                    large: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/large_Credit_Card_09359e242f.jpg`,
                      hash: "large_Credit_Card_09359e242f",
                      mime: "image/jpeg",
                      name: "large_Credit-Card.jpg",
                      path: null,
                      size: 71.49,
                      width: 1000,
                      height: 523,
                    },
                    small: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/small_Credit_Card_09359e242f.jpg`,
                      hash: "small_Credit_Card_09359e242f",
                      mime: "image/jpeg",
                      name: "small_Credit-Card.jpg",
                      path: null,
                      size: 21.89,
                      width: 500,
                      height: 262,
                    },
                    medium: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/medium_Credit_Card_09359e242f.jpg`,
                      hash: "medium_Credit_Card_09359e242f",
                      mime: "image/jpeg",
                      name: "medium_Credit-Card.jpg",
                      path: null,
                      size: 44.78,
                      width: 750,
                      height: 393,
                    },
                    thumbnail: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/thumbnail_Credit_Card_09359e242f.jpg`,
                      hash: "thumbnail_Credit_Card_09359e242f",
                      mime: "image/jpeg",
                      name: "thumbnail_Credit-Card.jpg",
                      path: null,
                      size: 6.04,
                      width: 245,
                      height: 128,
                    },
                  },
                },
              },
            },
            canonicalURL: null,
            metaRobots: null,
            keywords: null,
            structuredData: '"\\"null\\""',
          },
          metadataPrivacy: {
            metaTitle: "Privacy Policy | Onmo",
            metaDescription:
              "The Onmo Privacy Policy covers how we collect and store and protect your data, and your rights as a customer.",
            metaImage: {
              data: {
                id: "251",
                attributes: {
                  alternativeText: "Privacy-Policy.jpg",
                  width: 1200,
                  height: 628,
                  mime: "image/jpeg",
                  url: `https://d2f2p28idjlxwt.cloudfront.net/Privacy_Policy_0241f0a5df.jpg`,
                  formats: {
                    large: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/large_Privacy_Policy_0241f0a5df.jpg`,
                      hash: "large_Privacy_Policy_0241f0a5df",
                      mime: "image/jpeg",
                      name: "large_Privacy-Policy.jpg",
                      path: null,
                      size: 25.27,
                      width: 1000,
                      height: 523,
                    },
                    small: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/small_Privacy_Policy_0241f0a5df.jpg`,
                      hash: "small_Privacy_Policy_0241f0a5df",
                      mime: "image/jpeg",
                      name: "small_Privacy-Policy.jpg",
                      path: null,
                      size: 10.66,
                      width: 500,
                      height: 262,
                    },
                    medium: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/medium_Privacy_Policy_0241f0a5df.jpg`,
                      hash: "medium_Privacy_Policy_0241f0a5df",
                      mime: "image/jpeg",
                      name: "medium_Privacy-Policy.jpg",
                      path: null,
                      size: 17.85,
                      width: 750,
                      height: 393,
                    },
                    thumbnail: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/thumbnail_Privacy_Policy_0241f0a5df.jpg`,
                      hash: "thumbnail_Privacy_Policy_0241f0a5df",
                      mime: "image/jpeg",
                      name: "thumbnail_Privacy-Policy.jpg",
                      path: null,
                      size: 3.88,
                      width: 245,
                      height: 128,
                    },
                  },
                },
              },
            },
            canonicalURL: null,
            metaRobots: null,
            keywords: null,
            structuredData: null,
          },
          metadataTerms: {
            metaTitle: "Terms and Conditions | Onmo",
            metaDescription:
              "The finer details, including terms, charges, cancellations and how to complain.",
            metaImage: {
              data: {
                id: "252",
                attributes: {
                  alternativeText: "Term-Conditions.jpg",
                  width: 1200,
                  height: 628,
                  mime: "image/jpeg",
                  url: `https://d2f2p28idjlxwt.cloudfront.net/Term_Conditions_eff7de319f.jpg`,
                  formats: {
                    large: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/large_Term_Conditions_eff7de319f.jpg`,
                      hash: "large_Term_Conditions_eff7de319f",
                      mime: "image/jpeg",
                      name: "large_Term-Conditions.jpg",
                      path: null,
                      size: 31.22,
                      width: 1000,
                      height: 523,
                    },
                    small: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/small_Term_Conditions_eff7de319f.jpg`,
                      hash: "small_Term_Conditions_eff7de319f",
                      mime: "image/jpeg",
                      name: "small_Term-Conditions.jpg",
                      path: null,
                      size: 13.37,
                      width: 500,
                      height: 262,
                    },
                    medium: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/medium_Term_Conditions_eff7de319f.jpg`,
                      hash: "medium_Term_Conditions_eff7de319f",
                      mime: "image/jpeg",
                      name: "medium_Term-Conditions.jpg",
                      path: null,
                      size: 22.48,
                      width: 750,
                      height: 393,
                    },
                    thumbnail: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/thumbnail_Term_Conditions_eff7de319f.jpg`,
                      hash: "thumbnail_Term_Conditions_eff7de319f",
                      mime: "image/jpeg",
                      name: "thumbnail_Term-Conditions.jpg",
                      path: null,
                      size: 4.97,
                      width: 245,
                      height: 128,
                    },
                  },
                },
              },
            },
            canonicalURL: null,
            metaRobots: null,
            keywords: null,
            structuredData: null,
          },
          metadataCookie: {
            metaTitle: "Cookie Policy | Onmo",
            metaDescription:
              "An overview of what Cookies are and how we use them at Onmo. ",
            metaImage: {
              data: {
                id: "250",
                attributes: {
                  alternativeText: "Cookie.jpg",
                  width: 1200,
                  height: 628,
                  mime: "image/jpeg",
                  url: `https://d2f2p28idjlxwt.cloudfront.net/Cookie_6035080618.jpg`,
                  formats: {
                    large: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/large_Cookie_6035080618.jpg`,
                      hash: "large_Cookie_6035080618",
                      mime: "image/jpeg",
                      name: "large_Cookie.jpg",
                      path: null,
                      size: 61.61,
                      width: 1000,
                      height: 523,
                    },
                    small: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/small_Cookie_6035080618.jpg`,
                      hash: "small_Cookie_6035080618",
                      mime: "image/jpeg",
                      name: "small_Cookie.jpg",
                      path: null,
                      size: 17.09,
                      width: 500,
                      height: 262,
                    },
                    medium: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/medium_Cookie_6035080618.jpg`,
                      hash: "medium_Cookie_6035080618",
                      mime: "image/jpeg",
                      name: "medium_Cookie.jpg",
                      path: null,
                      size: 36.34,
                      width: 750,
                      height: 393,
                    },
                    thumbnail: {
                      ext: ".jpg",
                      url: `https://d2f2p28idjlxwt.cloudfront.net/thumbnail_Cookie_6035080618.jpg`,
                      hash: "thumbnail_Cookie_6035080618",
                      mime: "image/jpeg",
                      name: "thumbnail_Cookie.jpg",
                      path: null,
                      size: 4.3,
                      width: 245,
                      height: 128,
                    },
                  },
                },
              },
            },
            canonicalURL: null,
            metaRobots: null,
            keywords: null,
            structuredData: null,
          },
          metaTitleSuffix: null,
          notificationBanner: null,
          navbar: {
            signUpButton: false,
            links: [
              {
                id: "1",
                url: "/about",
                text: "About Onmo",
              },
              {
                id: "2",
                url: "/credit-card",
                text: "Credit Card",
              },
            ],
            logo: {
              data: {
                id: "261",
                attributes: {
                  alternativeText: null,
                  width: 250,
                  height: 64,
                  mime: "image/svg+xml",
                  url: `https://d2f2p28idjlxwt.cloudfront.net/Logo_Secondary_0adf06d19c.svg`,
                  formats: null,
                },
              },
            },
          },
        },
      },
      footer: {
        id: "1",
        copyright: "© {currentYear} Onmo Ltd. All Rights Reserved.",
        visaText:
          "Onmo Ltd. is authorised and regulated by the Financial Conduct Authority (FCA), ref. 940604. The company is registered in England & Wales (Number 12708619) at 33 Cannon Street, 4th Floor, London, England, EC4M 5SB.\n\nOnmo Visa Card is issued by Transact Payments Limited. Transact Payments is authorised and regulated by the Gibraltar Financial Services Commission. Visa is a registered trademark of Visa International Services Limited.\n\nDebit Account balances are held with PayrNet Limited, an authorised Electronic Money Institution (EMI). PayrNet is regulated by the FCA in the UK under the Electronic Money Regulations 2011 for the issuance of electronic money and the provision of payment services: FCA ref. 900594. Funds held with PayrNet are not FSCS protected.",
        appStoreIcons: true,
        columns: [
          {
            id: "1",
            title: "Company",
            links: [
              {
                id: "15",
                url: "/about",
                text: "About Onmo",
              },
            ],
          },
          {
            id: "2",
            title: "Products",
            links: [
              {
                id: "9",
                url: "/credit-card",
                text: "Credit Card",
              },
              {
                id: "11",
                url: "/business",
                text: "Onmo Pro",
              },
            ],
          },
          {
            id: "3",
            title: "Legal",
            links: [
              {
                id: "12",
                url: "/legal/privacy-policy",
                text: "Privacy Policy",
              },
              {
                id: "13",
                url: "/legal/terms-and-conditions",
                text: "Terms & Conditions",
              },
              {
                id: "14",
                url: "/legal/cookie-notice",
                text: "Cookie Notice",
              },
            ],
          },
          {
            id: "4",
            title: "Help",
            links: [
              {
                id: "21",
                url: "/faq",
                text: "FAQ",
              },
              {
                id: "22",
                url: "/contact-us",
                text: "Contact us",
              },
              {
                id: "24",
                url: "/complaints",
                text: "Complaints",
              },
              {
                id: "23",
                url: "/help/fx",
                text: "Foreign Exchange (FX)",
              },
            ],
          },
        ],
        logo: {
          data: {
            id: "215",
            attributes: {
              alternativeText: "Onmo",
              width: 92,
              height: 24,
              mime: "image/svg+xml",
              url: CMSUrls.onmoWhite,
              formats: null,
            },
          },
        },
      },
      creditApplications: true,
      debitApplications: false,
      biometricVerification: false,
      webLiveChat: true,
    },
  };
};
